import { render, staticRenderFns } from "./newenumSetting.vue?vue&type=template&id=114fa2f8&scoped=true&"
import script from "./newenumSetting.vue?vue&type=script&lang=js&"
export * from "./newenumSetting.vue?vue&type=script&lang=js&"
import style0 from "./newenumSetting.vue?vue&type=style&index=0&id=114fa2f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114fa2f8",
  null
  
)

export default component.exports